/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module ClientnotificationTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface ClientNotification {
    [k: string]: any;
}
/**
 * This interface was referenced by `ClientNotification`'s JSON-Schema
 * via the `definition` "ShowClientNotificationsParameters".
 */
export interface ShowClientNotificationsParameters {
    /**
     * Title of the Notification
     */
    title: string;
    /**
     * Body of the Notification
     */
    body: string;
    /**
     * Can be rtl (for arabic) or ltr
     */
    direction: string;
    /**
     * tag for identifing language
     */
    language: string;
    /**
     * unique id of particular notification
     */
    tag: string;
    /**
     * specifying whether the notification is silent (no sounds or vibrations issued), regardless of the device settings
     */
    silent?: boolean;
}
/**
 * This interface was referenced by `ClientNotification`'s JSON-Schema
 * via the `definition` "ClearNotificationsQueueParameters".
 */
export interface ClearNotificationsQueueParameters {
    /**
     * Command to clear
     */
    clear: boolean;
}
/**
 * This interface was referenced by `ClientNotification`'s JSON-Schema
 * via the `definition` "DeleteNotificationParameters".
 */
export interface DeleteNotificationParameters {
    /**
     * Unique Notification Id
     */
    uniqueId: string;
}

/**
 * Enum defining status
 *
 * This interface was referenced by `ClientNotification`'s JSON-Schema
 * via the `definition` "InternalErrorCodeEnum".
 */
export enum InternalErrorCodeEnum {
    Success = 0,
    Error = 1,
    Error_PermissionNotGiven = 2,
    Error_NotFullScreen = 3
}


}
